import { FormFieldsStrategyType } from "@/common/types";
import { FormCard } from "../UI";
import { Form, Input, Select } from "antd";
import { Fragment } from "react/jsx-runtime";
import Typography from "../Typography/Typography";
const { Option } = Select;

export default function BaseForm({
  formStrategy,
  data,
}: {
  formStrategy: FormFieldsStrategyType[];
  data?: Record<string, any>;
}) {
  return (
    <>
      <FormCard>
        {formStrategy.map((el) => (
          <Fragment key={el.name}>
            {el.inputType === "text" ? (
              <div className="w-full max-w-[290px]" key={el.name}>
                <Typography
                  type="span"
                  fontSize={14}
                  lineHeight={5}
                  fontWeight="font-normal"
                  uppercase
                  textColor="gray-dim"
                >
                  {el.label}
                </Typography>
                {el.required && (
                  <Typography type="span" textColor="red-main">
                    *
                  </Typography>
                )}
                <Form.Item
                  key={el.label}
                  name={el.name}
                  className="m-0 p-0 items-center justify-center "
                  initialValue={
                    el?.defaultValue ||
                    (typeof data !== "undefined" ? data[el.name] : "")
                  }
                  validateTrigger="onBlur"
                  rules={[
                    {
                      required: el.required,
                      message: el?.errorMessage || "This field is required",
                    },
                    !!el.pattern
                      ? {
                          pattern: el.pattern,
                          message: el.patternMessage,
                        }
                      : {},
                  ]}
                >
                  <Input
                    className="px-4 py-3 border-0 truncate"
                    readOnly={el.readonly}
                  />
                </Form.Item>
              </div>
            ) : (
              <div className="w-full max-w-[290px]" key={el.name}>
                <Typography
                  type="span"
                  fontSize={14}
                  lineHeight={5}
                  fontWeight="font-normal"
                  uppercase
                  textColor="gray-dim"
                >
                  {el.label}
                </Typography>
                <Form.Item
                  key={el.label}
                  name={el.name}
                  className="m-0 p-0"
                  initialValue={
                    el?.defaultValue ||
                    (typeof data !== "undefined" ? data[el.name] : "")
                  }
                >
                  <>
                    <Select
                      popupClassName="max-w-fit min-w-[290px]"
                      className="custom-select-antd text-base h-[46px] font-kanit !border-none rounded-lg "
                      variant="filled"
                      style={{
                        backgroundColor: "#F3F9FC",
                      }}
                    >
                      {typeof el?.options !== "undefined" &&
                        el?.options.map((option) => {
                          return (
                            <Option
                              key={`${option.label}-${el.name}`}
                              value={option.value}
                            >
                              {option.label}
                            </Option>
                          );
                        })}
                    </Select>
                  </>
                </Form.Item>
              </div>
            )}
          </Fragment>
        ))}
      </FormCard>
    </>
  );
}
